var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.displayLoading ? _c('div', [_c('Loading')], 1) : _vm._e(), _vm.isChecked ? _c('div', [_c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('form_page.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('form_page.step_section.steps')
    }
  })], 1) : _vm._e(), _vm.shouldDisplayVerifyFormRedirectionMessage && _vm.verifyFormRedirectionMessage ? _c('Toast', {
    staticClass: "mb-4",
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v(" " + _vm._s(_vm.verifyFormRedirectionMessage) + " ")]) : _vm._e(), _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("form_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('form_page.form_desc'))
    }
  }), _c('div', {
    staticClass: "form"
  }, _vm._l(_vm.fields.filter(function (x) {
    return x.hidden == undefined || !x.hidden;
  }), function (field, index) {
    var _field$config, _field$config$require, _field$config2, _field$config2$requir;
    return _c('div', {
      key: "field.".concat(index),
      staticClass: "field"
    }, [field.type === 'mobile_phone' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(_vm.displayTitle(field, "手機號碼")))]), _c('div', {
      staticClass: "d-flex"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form.mobile_phone,
        expression: "form.mobile_phone"
      }],
      staticClass: "field__input flex-fill google-sans-code",
      class: {
        invalid: _vm.v$.form.mobile_phone.$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "type": "tel",
        "placeholder": _vm.displayPlaceholder(field, '請輸入您的手機號碼'),
        "disabled": field.disabled || _vm.isMobileValidating || _vm.mobileIsValid
      },
      domProps: {
        "value": _vm.form.mobile_phone
      },
      on: {
        "keypress": function keypress($event) {
          return _vm.v$.$touch();
        },
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "mobile_phone", $event.target.value);
        }
      }
    }), _vm.getModuleConfig('form_page.enable_sms_check') ? _c('SharedButton', {
      staticClass: "ml-3 w-auto text-nowrap s-btn-bg-primary",
      attrs: {
        "disabled": !_vm.form.mobile_phone || _vm.v$.form.mobile_phone.$error || _vm.isMobileValidating || _vm.mobileIsValid
      },
      on: {
        "click": _vm.sendMobile
      }
    }, [_vm.isMobileValidating && _vm.counter > 0 ? [_vm._v(" " + _vm._s(_vm.counterMessage) + " ")] : _vm.mobileIsValid ? [_vm._v(_vm._s(_vm.trans('mobile_verified', '已驗証')))] : [_vm._v(" " + _vm._s(_vm.trans('send_sms_code', '傳送驗證碼')) + " ")]], 2) : _vm._e(), !_vm.isMobileValidating && !_vm.mobileIsValid && _vm.user.phone_verified_at != null || _vm.isMobileValidating ? _c('button', {
      staticClass: "btn btn-link text-nowrap ml-3",
      on: {
        "click": function click() {
          _vm.isMobileValidating = false;
          _vm.mobileIsValid = _vm.user.phone_verified_at != null;
          _vm.form.mobile_phone = _vm.user.mobile_phone;
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.trans('cancel', '取消')) + " ")]) : _vm._e(), _vm.mobileIsValid && !_vm.isMobileValidating ? _c('button', {
      staticClass: "btn btn-link text-nowrap ml-3",
      on: {
        "click": function click($event) {
          _vm.mobileIsValid = false;
        }
      }
    }, [_vm._v(" " + _vm._s(_vm.trans('revise', '修改')) + " ")]) : _vm._e()], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form.mobile_phone.$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e(), _vm.mobileValidMessage ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.mobileValidMessage) + " ")]) : _vm._e(), _vm.v$.mobileIsValid.$invalid ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.trans('not_verify_phone_number', '手機號碼未驗証')) + " ")]) : _vm._e(), _vm.isMobileValidating ? _c('div', {
      staticClass: "d-flex align-items-start my-3"
    }, [_c('div', {
      staticClass: "code-input flex-fill"
    }, [_c('CodeInput', {
      class: {
        invalid: !_vm.codeIsValid
      },
      attrs: {
        "loading": false,
        "fields": 6,
        "fieldHeight": 50
      },
      on: {
        "change": function change(e) {
          return _vm.verificationCode = e;
        }
      }
    }), !_vm.codeIsValid ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(_vm.codeValidMessage) + " ")]) : _vm._e()], 1), _c('div', {
      staticClass: "flex-fill ml-3"
    }, [_c('SharedButton', {
      staticClass: "text-nowrap s-btn-bg-primary",
      attrs: {
        "disabled": _vm.verificationCode.length != 6
      },
      on: {
        "click": _vm.verifyMobile
      }
    }, [_vm._v(" " + _vm._s(_vm.trans('confirm', '確定')) + " ")])], 1)]) : _vm._e()]) : field.type === 'date' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "field__select-group",
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-year")].$error || _vm.v$.form["".concat(field.field_key, "-month")].$error || _vm.v$.form["".concat(field.field_key, "-day")].$error
      }
    }, [_c('SharedSelect', {
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-year")].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "id": "".concat(field.field_key, "-year"),
        "options": _vm.yearOptions,
        "hasBorder": false,
        "placeholder": _vm.trans('years', '年份'),
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-year")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-year"), $$v);
        },
        expression: "form[`${field.field_key}-year`]"
      }
    }), _c('SharedSelect', {
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-month")].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "id": "".concat(field.field_key, "-month"),
        "options": _vm.monthOptions,
        "hasBorder": false,
        "placeholder": _vm.trans('months', '月份'),
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-month")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-month"), $$v);
        },
        expression: "form[`${field.field_key}-month`]"
      }
    }), _c('SharedSelect', {
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-day")].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "id": "".concat(field.field_key, "-day"),
        "options": _vm.dayOptions(_vm.form["".concat(field.field_key, "-year")], _vm.form["".concat(field.field_key, "-month")]),
        "hasBorder": false,
        "placeholder": _vm.trans('day', '日'),
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-day")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-day"), $$v);
        },
        expression: "form[`${field.field_key}-day`]"
      }
    })], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form["".concat(field.field_key, "-year")].$error || _vm.v$.form["".concat(field.field_key, "-month")].$error || _vm.v$.form["".concat(field.field_key, "-day")].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()]) : field.type === 'address' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null
    }, [_vm._v(_vm._s(_vm.displayTitle(field, "地址")))]), _c('div', {
      staticClass: "field__select-group mb-3 city-selector-set-has-value"
    }, [_c('SharedSelect', {
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-city")].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "id": "".concat(field.field_key, "-city"),
        "hasBorder": false,
        "selectClass": "county",
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-city")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-city"), $$v);
        },
        expression: "form[`${field.field_key}-city`]"
      }
    }), _c('SharedSelect', {
      class: {
        invalid: _vm.v$.form["".concat(field.field_key, "-district")].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "id": "".concat(field.field_key, "-district"),
        "hasBorder": false,
        "selectClass": "district",
        "disabled": field.disabled
      },
      model: {
        value: _vm.form["".concat(field.field_key, "-district")],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key, "-district"), $$v);
        },
        expression: "form[`${field.field_key}-district`]"
      }
    })], 1), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form["".concat(field.field_key, "-address")],
        expression: "form[`${field.field_key}-address`]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.shouldDisplayVerifyFormRedirectionErrorState || _vm.v$.form["".concat(field.field_key, "-address")].$error || _vm.v$.form["".concat(field.field_key, "-district")].$error || _vm.v$.form["".concat(field.field_key, "-city")].$error
      },
      attrs: {
        "id": "".concat(field.field_key, "-address"),
        "placeholder": _vm.displayPlaceholder(field, '請輸入詳細地址'),
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form["".concat(field.field_key, "-address")]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "".concat(field.field_key, "-address"), $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e()]) : field.type === 'email' ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "d-flex align-items-center"
    }, [(_field$config = field.config) !== null && _field$config !== void 0 && (_field$config$require = _field$config.required_check) !== null && _field$config$require !== void 0 && _field$config$require.enabled ? _c('Checkbox', {
      attrs: {
        "name": "email_checkbox"
      },
      on: {
        "change": function change(value) {
          !value && (_vm.form[field.field_key] = '');
        }
      },
      model: {
        value: field.config.required_check.checked,
        callback: function callback($$v) {
          _vm.$set(field.config.required_check, "checked", $$v);
        },
        expression: "field.config.required_check.checked"
      }
    }) : _vm._e(), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form["".concat(field.field_key)],
        expression: "form[`${field.field_key}`]"
      }],
      staticClass: "field__input",
      class: {
        invalid: _vm.v$.form[field.field_key].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled || ((_field$config2 = field.config) === null || _field$config2 === void 0 ? void 0 : (_field$config2$requir = _field$config2.required_check) === null || _field$config2$requir === void 0 ? void 0 : _field$config2$requir.enabled) && !field.config.required_check.checked,
        "type": "email"
      },
      domProps: {
        "value": _vm.form["".concat(field.field_key)]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "".concat(field.field_key), $event.target.value);
        }
      }
    })], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()]) : field.type === 'select' && field.matched_key && !field.provider ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('SharedSelect', {
      class: {
        invalid: _vm.v$.form[field.field_key].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "options": field.options,
        "hasBorder": false,
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled,
        "selectClass": _vm.shouldDisplayVerifyFormRedirectionErrorState ? 'invalid' : ''
      },
      model: {
        value: _vm.form["".concat(field.field_key)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key), $$v);
        },
        expression: "form[`${field.field_key}`]"
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()], 1) : field.type === 'branch' && field.matched_key && field.provider ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('ShopSelection', {
      ref: "shop-selection-".concat(field.field_key),
      refInFor: true,
      attrs: {
        "branch-provider": field.provider,
        "show-branch-code": !!field.show_branch_code,
        "placeholder": _vm.displayPlaceholder(field, '請選擇分店櫃點'),
        "invalid": _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      model: {
        value: _vm.form["".concat(field.field_key)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key), $$v);
        },
        expression: "form[`${field.field_key}`]"
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form["".concat(field.field_key)].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()], 1) : field.type === 'radio' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "s-flex flex-wrap",
      class: field.is_vertical && 'flex-column'
    }, _vm._l(field.options, function (option, index) {
      return _c('SharedRadioButton', {
        key: field.title + index,
        attrs: {
          "id": field.title + index,
          "value": option.value,
          "name": field.matched_key,
          "disabled": field.disabled,
          "invalid": _vm.shouldDisplayVerifyFormRedirectionErrorState
        },
        model: {
          value: _vm.form["".concat(field.field_key)],
          callback: function callback($$v) {
            _vm.$set(_vm.form, "".concat(field.field_key), $$v);
          },
          expression: "form[`${field.field_key}`]"
        }
      }, [_vm._v(" " + _vm._s(option.text) + " ")]);
    }), 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form["".concat(field.field_key)].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()]) : field.type === 'checkbox' && field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('div', {
      staticClass: "s-flex checkbox-field"
    }, [_c('b-form-checkbox-group', {
      attrs: {
        "options": field.options,
        "stacked": field.is_vertical,
        "disabled": field.disabled,
        "state": _vm.shouldDisplayVerifyFormRedirectionErrorState ? false : null
      },
      model: {
        value: _vm.form["".concat(field.field_key)],
        callback: function callback($$v) {
          _vm.$set(_vm.form, "".concat(field.field_key), $$v);
        },
        expression: "form[`${field.field_key}`]"
      }
    })], 1), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form["".concat(field.field_key)].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()]) : field.matched_key ? _c('div', [_c('label', {
      staticClass: "field__label",
      class: field.required === true ? 'field--required' : null,
      attrs: {
        "id": field.field_key
      }
    }, [_vm._v(_vm._s(field.title))]), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.form["".concat(field.field_key)],
        expression: "form[`${field.field_key}`]"
      }],
      staticClass: "field__input google-sans-code",
      class: {
        invalid: _vm.v$.form[field.field_key].$error || _vm.shouldDisplayVerifyFormRedirectionErrorState
      },
      attrs: {
        "placeholder": _vm.displayPlaceholder(field),
        "disabled": field.disabled
      },
      domProps: {
        "value": _vm.form["".concat(field.field_key)]
      },
      on: {
        "input": function input($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.form, "".concat(field.field_key), $event.target.value);
        }
      }
    }), field.memo ? _c('small', {
      staticClass: "field__desc"
    }, [_vm._v(_vm._s(field.memo))]) : _vm._e(), _vm.v$.form[field.field_key].$error ? _c('div', {
      staticClass: "form__error-msg"
    }, [_vm._v(" " + _vm._s(field.validate_error_message || _vm.validateErrorMessage) + " ")]) : _vm._e()]) : _vm._e()]);
  }), 0)], 1), _c('div', {
    staticClass: "reminder",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('form_page.reminder'))
    }
  }), _vm.getModuleConfig('form_page.enable_terms_check') && _vm.getModuleConfig('form_page.terms_check') ? _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "margin-left": "12px"
    }
  }, [_c('b-form-checkbox', {
    staticClass: "my-auto ml-2",
    model: {
      value: _vm.termCheck,
      callback: function callback($$v) {
        _vm.termCheck = $$v;
      },
      expression: "termCheck"
    }
  }), _c('div', {
    staticClass: "terms_check",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('form_page.terms_check'))
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "page__button"
  }, [_c('SharedButton', {
    staticClass: "s-btn-bg-primary",
    attrs: {
      "disabled": !_vm.termCheck
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("form_page.button_text") || '送出') + " ")])], 1)]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }